/** @jsxImportSource @emotion/react */
import React from 'react';
import { style as s } from '../style';
import { Button } from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import DownloadFileIcon from '@mui/icons-material/Download';
import { styled } from '@mui/material/styles';

const DataAddModal = ({ 
    isOpen,
    onClose,
    fileInputRef,
    isDragActive,
    handleDrop,
    handleDragOver,
    handleDragLeave,
    handleClick,
    handleDownload1,
    handleDownload2,
}) => {

    return (
        // 오버레이
        <div css={s.modalOverlay} onClick={onClose}>

            {/* 모달 컨테이너 */}
            <div css={s.modalContainer} onClick={(e) => e.stopPropagation()}>
                {/* 헤더 */}
                <div css={s.modalHeader}>
                    <h3>지도에 데이터 추가하기</h3>
                    <button onClick={onClose}>&times;</button>
                </div>

                {/* 본문 */}
                <div>
                    <h4 css={s.modalSectionTitle}>데이터 업로드</h4>
                        <div css={s.modalUploadInfo}>
                            <ul>
                                <li>ZIP(Shape), GeoJSON 형태의 파일을 등록할 수 있습니다.</li>
                                <li>파일 1개당 크기는 10MB를 초과할 수 없으며, 최대 5개까지 등록할 수 있습니다.</li>
                            </ul>
                        </div>
                </div>

                {/* Drag & Drop */}
                <div 
                    css={s.modalDragDropArea}
                    onDrop={handleDrop} 
                    onDragOver={handleDragOver} 
                    onDragLeave={handleDragLeave}
                    data-dragging={isDragActive}
                >
                    <p css={s.modalInfoText}>업로드할 파일을 여기에 끌어 놓거나, 파일 선택 버튼을 눌러 파일을 직접 선택해 주세요.</p>
                    <button
                        // variant="outlined"
                        onClick={handleClick}
                        // startIcon={<UploadFileIcon />}
                        // sx={{
                        //     borderColor: '#002755',
                        //     color: '#002755',
                        //     fontWeight: 600,
                        //     '&:hover': { borderColor: '#001a3f' },
                        // }}
                        css={s.commonButton}
                        >
                        <UploadFileIcon />
                        파일 선택
                    </button>
                    {/* </Button> */}
                </div>

                {/* 샘플 데이터 다운로드 */}
                <div css={[s.modalInfoText, s.mh10]}>데이터가 필요하신가요?</div>
                <h4 css={s.modalSectionTitle}>샘플 데이터 다운로드</h4>
                <div css={s.modalDownloadContainer}>
                    {/* <Button
                        variant="outlined"
                        endIcon={<DownloadFileIcon />}
                        onClick={handleDownload1}
                        className="sample-button"
                    >
                        행정구역 샘플
                    </Button>
                    <Button
                        variant="outlined"
                        endIcon={<DownloadFileIcon />}
                        onClick={handleDownload2}
                        className="sample-button"
                    >
                        점포데이터 샘플
                    </Button> */}
                    <button 
                        css={s.modalDownloadButton}
                        onClick={handleDownload1}
                    >
                        대한민국 행정구역 (GeoJSON)
                        <DownloadFileIcon />
                    </button>
                    <button 
                        css={s.modalDownloadButton}
                        onClick={handleDownload2}
                    >
                        전국 점포 데이터 (GeoJSON)
                        <DownloadFileIcon />
                    </button>
                </div>

            </div>
        </div>
    );
};

export default DataAddModal;